require('./audio-file.component.scss');

const MEDIA_ERR_ABORTED = 1; // fetching process aborted by user
const MEDIA_ERR_NETWORK = 2; // error occurred when downloading
const MEDIA_ERR_DECODE = 3; // error occurred when decoding
const MEDIA_ERR_SRC_NOT_SUPPORTED = 4; // audio/video not supported

const MEDIA_ERROR_CODE = {
  '1': gettext('Отменено'),
  '2': gettext('Ошибка сети'),
  '3': gettext('Ошибка кодека'),
  '4': gettext('Не поддерживается'),
};

/*@ngInject*/
class AudioFileController {
  constructor(
    $scope,
    $http,
    $element,
    $timeout,
    LayoutService,
    AudioService,
    AudioViewerService,
  ) {
    this.$http = $http;
    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.layout = LayoutService;
    this.audioService = AudioService;
    this.AudioViewerService = AudioViewerService;

    this.currentTime = 0;
    this.duration = 0;
    this.audioErrors = MEDIA_ERROR_CODE;
    this.playing = false;
    this.$showTimeRange = true;

    // error occurred during the loading or playing
    $scope.$on('col-resize', () => {
      this.setTimeRange();
      this.$scope.$digest();
    });
    $scope.$on('resize', () => this.setTimeRange());
    $scope.$on('splitter1Changed', () => this.setTimeRange());

    this.onError = () => {
      // if (this.audio.error.code === MEDIA_ERR_NETWORK) {
      //   this.reload();
      // }
      this.playing = false;
      $scope.$digest();
    };

    // the audio has been started or is no longer paused
    this.onPlay = () => {
      this.playing = true;
      this.audioService.stopped = false;
      $scope.$digest();
    };

    // the audio has been paused
    this.onPause = () => {
      this.playing = false;
      this.audioService.stopped = true;
      $scope.$digest();
    };

    // the audio is ended
    this.onEnded = () => {
      this.playing = false;
      $scope.$digest();
    };

    // duration data is changed
    this.onDurationChange = () => {
      this.updateDuration();
      $scope.$digest();
    };

    // position is changed
    this.onTimeUpdate = () => {
      // console.log('onTimeUpdate', );
      this.updateCurrentTime();
      $scope.$digest();
    };
  }

  get fileName() {
    return `${this.fact['agent_agent.computer_name']}_${
      this.fact.local_time.substring(0, 19).replace(/:/gi, '').replace(/T/gi, '_')
    }.${this.audioService.downloadType}`;
  }

  reload() {
    if (this.reloading) {
      return;
    }
    this.reloading = true;
    if (this.audio.error.code === MEDIA_ERR_DECODE ||
      this.audio.error.code === MEDIA_ERR_SRC_NOT_SUPPORTED) {
      return this.$http.get(this.audio.src + '&reset=true')
        .catch(err => {
          if (err.status === 404) {
            return;
          }
          console.error(err.message);
        })
        .finally(() => this.reloadAudio());
    }
    this.reloadAudio();
  }

  reloadAudio() {
    this.audio.load();
    this.updateDuration();
    this.updateCurrentTime();
    this.reloading = false;
  }

  $onInit() {
    this.createAudio();
  }

  $onDestroy() {
    this.disposeAudio();
  }

  createAudio() {
    // let audio = this.audio = this.fact.audio = this.fact.audio || this.audioService.createAudio(this.src);
    this.fact.audio = this.fact.audio || this.audioService.createAudio(this.src);
    this.audio = this.fact.audio;
    const audio = this.audio;
    audio.addEventListener('error', this.onError);
    audio.addEventListener('play', this.onPlay);
    audio.addEventListener('pause', this.onPause);
    audio.addEventListener('ended', this.onEnded);
    audio.addEventListener('timeupdate', this.onTimeUpdate);
    audio.addEventListener('durationchange', this.onDurationChange);

    this.updateDuration();
    this.updateCurrentTime();
    if (this.layout.isFirefox) {
      this.$timeout(() => {
        this.timeRangeElement = this.$element.find('input.play-audio-time-range')[0];
        if (this.timeRangeElement) {
          this.timeRangeElement.addEventListener('mousedown', this.mouseDown.bind(this));
          this.timeRangeElement.addEventListener('mouseup', this.mouseUp.bind(this));
          this.$scope.$watch('$ctrl.currentTime', () =>
            this.timeRangeElement.value = this.currentTime);
        }
      }, 10);
    }
  }

  mouseDown() {
    this.timeRangeElement.addEventListener('mousemove', this.onSeek.bind(this));
    this.onSeek();
  }

  mouseUp() {
    this.timeRangeElement.removeEventListener('mousemove', this.onSeek);
    this.updateInputRange();
  }

  onSeek(e) {
    if (this.layout.isFirefox) {
      const now = (new Date()).getTime();
      if (this.mouseMoveLastTime && now - this.mouseMoveLastTime < 100) return;
      this.mouseMoveLastTime = now;
      this.currentTime = this.timeRangeElement.value;
    }
    this.audio.currentTime = this.currentTime;
    this.updateCurrentTime();
  }

  updateInputRange() {
    if (this.layout.isFirefox) {
      this.onSeek();
      const newRange = this.timeRangeElement.cloneNode(true);
      const parent = this.timeRangeElement.parentNode;
      parent.replaceChild(newRange, this.timeRangeElement);
      this.timeRangeElement = newRange;
      this.timeRangeElement.addEventListener('mousedown', this.mouseDown.bind(this));
      this.timeRangeElement.addEventListener('mouseup', this.mouseUp.bind(this));
    } else this.onSeek();
  }

  disposeAudio() {
    const audio = this.audio;
    audio.removeEventListener('error', this.onError);
    audio.removeEventListener('play', this.onPlay);
    audio.removeEventListener('pause', this.onPause);
    audio.removeEventListener('ended', this.onEnded);
    audio.removeEventListener('timeupdate', this.onTimeUpdate);
    audio.removeEventListener('durationchange', this.onDurationChange);
    if (this.layout.isFirefox) {
      this.timeRangeElement.removeEventListener('mousedown', this.mouseDown);
      this.timeRangeElement.removeEventListener('mouseup', this.mouseUp);
    }
    if (this.playing && !this.audioService.stopped) {
      this.play();
      this.audioService.stopped = true;
    }
  }

  play() {
    this.AudioViewerService.play(this.fact);
    this.fact.audioLoad = true;
  }

  updateDuration() {
    const duration = this.audio.duration;
    this.duration = Math.floor(duration);
  }

  updateCurrentTime() {
    this.currentTime = Math.floor(this.audio.currentTime);
  }

  get downloadSrc() {
    return this.audioService.getSrcType(
      this.src,
      this.audioService.downloadType,
    );
  }

  setTimeRange() {
    this.$showTimeRange = this.$element.parent().width() > 280;
  }

  get showTimeRange() {
    return this.$showTimeRange;
  }

  get showTime() {
    return this.playing || this.isSelected && this.hasDuration;
  }

  get isSelected() {
    return this.fact.selected;
  }

  get hasDuration() {
    return typeof this.audio.duration === 'number' &&
      !isNaN(this.audio.duration) && isFinite(this.audio.duration);
  }
}

export const AudioFileComponent = {
  template: require('./audio-file.component.html'),
  controller: AudioFileController,
  bindings: {
    fact: '<',
    src: '<',
  },
  // resolve: '^facts'
};



// WEBPACK FOOTER //
// ./src/facts/audio/audio-file.component.js